import { render, staticRenderFns } from "./IdInfoModal.vue?vue&type=template&id=54a4c40d&"
import script from "./IdInfoModal.vue?vue&type=script&lang=js&"
export * from "./IdInfoModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports